<app-long-card [embedMode]="isEmbedMode">
  <!-- Top Controls (hidden in embed mode) -->
  <div class="top-controls" *ngIf="!isEmbedMode">
    <app-language-selector></app-language-selector>
    <app-light-dark-switch></app-light-dark-switch>
  </div>

  <!-- Message -->
  <p class="welcome-subtitle">{{ "reset.message" | translate }}</p>

  <form [formGroup]="form" autocomplete="off">
    <div *ngIf="!showCompany">
      <div class="form-group">
        <label class="form-label">{{ "email" | translate }}</label>
        <input
          type="email"
          class="form-input"
          formControlName="usrEmail">
        <div class="form-error" *ngIf="form.controls['usrEmail'].errors && form.get('usrEmail').touched">
          {{ "error.email" | translate }}
        </div>
      </div>

      <div class="form-group">
        <label class="form-label">{{ "firstName" | translate }}</label>
        <input
          type="text"
          class="form-input"
          formControlName="usrFirstName">
        <div class="form-error" *ngIf="form.controls['usrFirstName'].errors && form.get('usrFirstName').touched">
          {{ "required" | translate }}
        </div>
      </div>

      <div class="form-group">
        <label class="form-label">{{ "lastname" | translate }}</label>
        <input
          type="text"
          class="form-input"
          formControlName="usrLastName">
        <div class="form-error" *ngIf="form.controls['usrLastName'].errors && form.get('usrLastName').touched">
          {{ "required" | translate }}
        </div>
      </div>

      <div *ngIf="successMsg != null" class="alert alert-primary">
        {{ successMsg?.message }}
      </div>

      <button type="button" class="btn-primary" (click)="onNext()" [disabled]="!form.valid">
        {{ "next" | translate }}
      </button>
    </div>

    <div *ngIf="showCompany">
      <div class="form-group">
        <label class="form-label">{{ "company" | translate }}</label>
        <select class="form-input form-select" formControlName="usrFranchises">
          <option value="" disabled>{{ "company" | translate }}</option>
          <option [value]="data.fTypeID" *ngFor="let data of franchises$">
            {{data.fTypeName}}
          </option>
        </select>
      </div>

      <button type="submit" class="btn-primary" (click)="onSubmit()" [disabled]="!form.valid">
        {{ "login.resetPassword" | translate }}
      </button>
    </div>
  </form>

  <!-- Back to Login -->
  <div class="back-to-login">
    <a [routerLink]="['/login']" [queryParams]="isEmbedMode ? {embed: 'true'} : {}">{{ "login.backToLogin" | translate }}</a>
  </div>
</app-long-card>